// START_MODULE pages_main_sections_statistics_components_statisticitem_statisticitem_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Display the maintained statistic value immediately without a counting animation.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';
import styled from 'styled-components';

import { IChildren } from 'utils/interfaces/IChildren';

interface StatisticItemProps extends IChildren {
  title: string;
  number: number;
  prefix?: string;
}

const StatisticItem: React.FC<StatisticItemProps> = ({
  title, number, prefix, children,
}) => (
  <StatisticItemContainer>
    {children}
    <h6>{title}</h6>
    <span>
      {`${prefix ?? ''} `}
      <span>{number}</span>
    </span>
  </StatisticItemContainer>
);

export default StatisticItem;

const StatisticItemContainer = styled.div`
  width: 200px;
  text-align: center;
  color: white;

  svg {
    margin-bottom: 8px;
  }
  >h6 {
    font-size: 1.2rem;
    margin-bottom: 8px;
  }
  span {
    font-size: 2.2rem;
    font-weight: bold;
  }
`;

// END_MODULE pages_main_sections_statistics_components_statisticitem_statisticitem_tsx
